import queryString from "query-string";

import { BUSINESS_REGISTRATION } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeBusinessRegistration } from "lib/serializers/businessRegistrations";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

// Mirrors the business list, which registrations are scoped to.
const urlCreator = (props: URLCreatorProps = {}) => {
  const { id, action, changesSince, saleyardNameFilter } = props;
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/business-registrations/", id, action),
    query: {
      changesSince,
      saleyard__name: saleyardNameFilter,
    },
  });
};

// Registrations are read only - they're found via lookup, and only the server updates them.
export const BusinessRegistrationAction = offlineActionCreator(
  BUSINESS_REGISTRATION,
  serializeBusinessRegistration,
  urlCreator,
  false,
);

export interface BusinessRegistrationLookupPayload {
  abn?: string;
  acn?: string;
}

export interface BusinessRegistrationRequestOptions {
  onSuccess?: (registration: BusinessRegistration) => void;
  onError?: (errors: Record<string, string[]> | null) => void;
}

export const lookupBusinessRegistration = (
  payload: BusinessRegistrationLookupPayload,
  options?: BusinessRegistrationRequestOptions,
) => ({
  type: BUSINESS_REGISTRATION.LOOKUP.REQUEST,
  payload,
  options,
});

export const requeryBusinessRegistration = (
  id: string,
  options?: BusinessRegistrationRequestOptions,
) => ({
  type: BUSINESS_REGISTRATION.REQUERY.REQUEST,
  payload: { id },
  options,
});
